// src/router/routes.mobile.ts
import type { RouteRecordRaw } from 'vue-router';
import { mobileAuthRoutes } from './domains/mobile-auth.routes';
import { mobileVisitsRoutes } from './domains/visits.routes';
import { mobileCalendarRoutes } from './domains/calendar.routes';
import { mobilePatientRoutes } from './domains/patients.routes';
import { mobilePaymentRoutes } from './domains/payments.routes';
import { mobileProfileRoutes } from './domains/profile.routes';

// Mobile routes mirror the web canonical URL scheme (web is the source of
// truth). All authenticated sections live under a single MobileLayout mounted
// at '/', with each domain's paths/names/aliases matching web so a path
// resolves to the equivalent screen on both platforms.
export const mobileRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('layouts/MobileAuthLayout.vue'),
    meta: { public: true },
    children: mobileAuthRoutes,
  },
  {
    path: '/',
    component: () => import('layouts/MobileLayout.vue'),
    children: [
      ...mobileVisitsRoutes,
      ...mobileCalendarRoutes,
      ...mobilePatientRoutes,
      ...mobilePaymentRoutes,
      ...mobileProfileRoutes,
    ],
  },
  { path: '/:catchAll(.*)*', redirect: '/home' },
];
